import { FC } from "react";
import ReactPaginate from "react-paginate";

interface PaginationProps {
    onPageChange: (pageInfo: { selected: number, limit: number }) => void;
    count: number;
    page: number;
    limit: number;
}

const Pagination: FC<PaginationProps> = ({ onPageChange, page, count, limit }) => {
    const perPageOptions: number[] = [10, 30, 50, 100];
    const handlePerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = parseInt(event.target.value, 10);
        console.log(value)
        if (value !== limit) {
            onPageChange({ selected: 0, limit: value });
        }
    };

    const handlePageChange = (pageInfo: { selected: number }) => {
        onPageChange({ ...pageInfo, limit });
    };

    return (
        <div className="w-full flex justify-between items-center py-4">
            <div className="flex items-center gap-4">
                <div className="w-20">
                    <select 
                        name="limit"
                        value={limit}
                        onChange={handlePerPageChange} 
                        className="w-full h-10 border border-gray-300 rounded px-2"
                    >
                        {perPageOptions.map((item) => (
                            <option key={item}  value={item}>{item}</option>
                        ))}
                    </select>
                </div>
                <span className="text-gray-800 text-sm">
                    {count < page * limit ? count : page * limit} of {count}
                </span>
            </div>
            <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageChange}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(count / limit)}
                previousLabel="<"
                renderOnZeroPageCount={null}
                forcePage={page - 1}
                containerClassName="flex list-none gap-2 flex-wrap"
                pageLinkClassName="px-3 py-2 text-gray-700 text-sm font-bold border border-gray-300 rounded hover:bg-gray-200"
                activeLinkClassName="bg-goldenOrangeBg text-white"
                previousLinkClassName="px-3 py-2 text-gray-700 text-sm font-bold"
                nextLinkClassName="px-3 py-2 text-gray-700 text-sm font-bold"
            />
        </div>
    );
};

export default Pagination;